import { useEffect } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { FormattedMessage } from 'react-intl';

import TopUpStatusMessage from './TopUpStatusMessage';
import messages from './TopUpStatusMessages.messages';

export const TopUpDeclined = () => {
    useEffect(() => {
        tracking.ampli.applicationDeclined();
    }, []);

    return (
        <TopUpStatusMessage
            heading={<FormattedMessage {...messages.topupDeclined} />}
        />
    );
};
